import { PositionModel } from '@customer/store/apis/assetsApi';
import { LatLngExpression } from 'leaflet';

export interface RotationModel {
  position: LatLngExpression;
  heading: number | null;
}

export const getRotationProps = (positionModel: PositionModel<number>): RotationModel => ({
  position: [positionModel.lat, positionModel.lon],
  heading: positionModel.hd,
});
